import _Object$assign from 'babel-runtime/core-js/object/assign';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import { fetchNewsInfo, creatNews, updateNews } from '@/api/website/news';
import { parseTime } from '@/filters/index';

import { blogLangType } from '../config';

export default {
  components: {},
  data: function data() {
    return {
      pageLoading: false,
      // 接口数据
      oldData: {},
      editType: '',
      formValue: {
        queryId: '',
        title: '',
        lang: '',
        type: '',
        content: '',
        cover_url: '',
        publish_time: parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}'),
        media_name: '',
        summary: '',
        links: ''
      },
      coverFileList: [],
      avatarFileList: [],
      editorContent: ''
    };
  },

  watch: {
    'formValue.cover_url': function formValueCover_url(val) {
      if (this.$refs['form']) {
        // 辅助校验，清除校验文案
        this.$refs['form'].validateField('cover_url');
      }
    }
  },
  computed: {
    formConfig: function formConfig() {
      return {
        labelPosition: 'left',
        labelWidth: '150px'
      };
    },
    formItemList: function formItemList() {
      var _this = this;

      return [{
        label: '适用语言：',
        prop: 'lang',
        type: 'radio-group',
        params: {
          options: blogLangType
        },
        rules: [{
          required: true,
          message: '请选择语言版本',
          trigger: 'change'
        }]
      }, {
        label: '标题：',
        type: 'input',
        prop: 'title',
        params: {
          style: 'width: 400px;'
        },
        rules: [{
          required: true,
          message: '请输入标题',
          trigger: 'blur'
        }, {
          min: 1,
          max: 200,
          message: '标题不能超过 200 个字符',
          trigger: 'blur'
        }]
      }, {
        label: '封面图：',
        type: 'business',
        subtype: 'file-uploader',
        prop: 'cover_url',
        rules: [{
          required: true,
          message: '请上传图片',
          trigger: 'change'
        }],
        params: function params() {
          var acceptType = ['jpg', 'png', 'jpeg'];
          var tip = '仅支持jpg, png, jpeg格式图片，推荐图片比例：16: 9，大小:  500kb以内';
          var temp = {
            disabled: false,
            drag: true,
            data: {
              local: 1,
              mod: 'website'
            },
            'with-credentials': true,
            acceptType: acceptType,
            tip: tip,
            style: 'width: 400px;',
            fileList: _this.coverFileList
          };
          return temp;
        },
        beforeUpload: this.beforeUpload,
        handleUploadSuccess: this.handleCoverUploadSuccess,
        handleRemove: this.handleCoverRemove
      }, {
        label: '发布时间：',
        type: 'date-picker',
        prop: 'publish_time',
        subtype: 'datetime',
        params: {
          format: 'yyyy-MM-dd HH:mm:ss',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          pickerOptions: {}
        },
        rules: [{
          required: true,
          message: '请选择发布时间',
          trigger: 'change'
        }]
      }, {
        label: '发布媒体名称：',
        type: 'input',
        prop: 'media_name',
        params: {
          style: 'width: 400px;'
        },
        rules: [{
          required: true,
          message: '请输入发布媒体名称',
          trigger: 'blur'
        }, {
          min: 1,
          max: 20,
          message: '发布者姓名不能超过 20 个字符',
          trigger: 'change'
        }]
      }, {
        label: '摘要',
        prop: 'summary',
        type: 'input',
        subtype: 'textarea',
        rules: [{
          required: true,
          message: '请输入摘要内容',
          trigger: 'blur'
        }, {
          min: 1,
          max: 160,
          message: '摘要内容不能超过 160 个字符',
          trigger: 'blur'
        }]
      }, {
        label: '报道链接：',
        type: 'input',
        subtype: 'textarea',
        prop: 'links',
        rules: [{
          required: true,
          message: '请输入报道链接',
          trigger: 'blur'
          // {
          //   min: 1,
          //   max: 200,
          //   message: '名称不能超过 200 个字符',
          //   trigger: 'blur'
          // }
        }]
      }, {
        label: '请输入正文：',
        type: 'business',
        subtype: 'main-editor',
        prop: 'content',
        rules: [{
          required: true,
          message: '请输入正文内容',
          trigger: 'blur'
        }]
      }];
    }
  },
  mounted: function mounted() {
    if (this.$route.params.id) {
      this.editType = 'edit';
      this.getNewsInfoById(this.$route.params.id);
    } else {
      this.editType = 'create';
    }
  },

  methods: {
    getNewsInfoById: function getNewsInfoById(id) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.pageLoading = true;
                _context.prev = 1;
                _context.next = 4;
                return fetchNewsInfo(id, {});

              case 4:
                res = _context.sent;

                if (_.get(res, 'data.code', '') === 0) {
                  // this.oldData = _.get(res, 'data.data.info', {})
                  _this2.fillForm(_.get(res, 'data.data.info', {}));
                }
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);

                console.log(_context.t0);

              case 11:
                _this2.pageLoading = false;

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 8]]);
      }))();
    },
    handleGoBack: function handleGoBack() {
      var _this3 = this;

      this.$confirm('是否放弃当前编辑内容，返回列表页？', '提示', {
        type: 'warning'
      }).then(function () {
        _this3.$router.push('/website/news');
      }).catch(function () {
        //
      });
    },
    beforeUpload: function beforeUpload(file) {
      var isPIC = ['jpg', 'png', 'jpeg'].some(function (item) {
        return file.type.indexOf(item) !== -1;
      });
      var isLt500 = file.size / 1024 < 500;
      if (isPIC && !isLt500) {
        this.$message.error('上传图片不能超过500kb');
        return isPIC && isLt500;
      }
      return true;
    },

    // 填充表单
    fillForm: function fillForm(data) {
      var obj = _.pick(data, ['lang', 'title', 'cover_url', 'content', 'publish_time', 'links', 'media_name', 'summary']);
      obj.publish_time = parseTime(new Date(obj.publish_time).getTime(), '{y}-{m}-{d} {h}:{i}:{s}');
      _Object$assign(this.oldData, obj);
      obj.queryId = data.id;
      _Object$assign(this.formValue, obj);
      if (obj.cover_url) {
        this.coverFileList = [{
          name: data.cover_name,
          url: data.cover_url
        }];
      }
    },

    // 封面
    handleCoverUploadSuccess: function handleCoverUploadSuccess(response, file, fileList) {
      if (response.code === 0) {
        // 当上传的图片都成功之后，为file_path赋值
        this.coverFileList = [{
          name: response.data.origin_name,
          url: response.data.url
        }];
        this.formValue.cover_url = response.data.file_path;
      } else {
        file.status = 'fail';
        this.$message({
          message: response.msg ? response.msg : '上传失败，请重新尝试',
          type: 'warning'
        });
      }
    },
    handleCoverRemove: function handleCoverRemove(file, fileList) {
      this.coverFileList = [];
      this.formValue.cover_url = '';
    },
    submitNews: function submitNews() {
      var postData = {};
      _Object$assign(postData, _.pick(this.formValue, ['title', 'lang', 'cover_url', 'content', 'summary', 'publish_time', 'media_name', 'links']));
      if (this.editType === 'create') {
        this.handleCreateNews(postData);
      } else {
        this.handleUpdateNews(postData);
      }
    },
    handleCreateNews: function handleCreateNews(postData) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.pageLoading = true;
                _context2.prev = 1;
                _context2.next = 4;
                return creatNews(postData);

              case 4:
                res = _context2.sent;

                _this4.pageLoading = false;
                if (_.get(res, 'data.code', '') === 0) {
                  _this4.$message({
                    message: '创建成功',
                    type: 'success'
                  });
                  _this4.$router.push('/website/news');
                } else {
                  _this4.$message(_.get(res, 'data.msg', ''));
                }
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](1);

                _this4.pageLoading = false;
                //

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[1, 9]]);
      }))();
    },
    handleUpdateNews: function handleUpdateNews(postData) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var omitPostData, key, res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.pageLoading = true;
                _context3.prev = 1;
                omitPostData = {};
                // 遍历对比json

                for (key in postData) {
                  if (postData[key] !== _this5.oldData[key]) {
                    omitPostData[key] = postData[key];
                  }
                }
                _context3.next = 6;
                return updateNews(_this5.formValue.queryId, omitPostData);

              case 6:
                res = _context3.sent;

                _this5.pageLoading = false;
                if (_.get(res, 'data.code', '') === 0) {
                  _this5.$message({
                    message: '更新成功',
                    type: 'success'
                  });
                  _this5.$router.push('/website/news');
                } else {
                  _this5.$message(_.get(res, 'data.msg', ''));
                }
                _context3.next = 14;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3['catch'](1);

                _this5.pageLoading = false;
                //

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[1, 11]]);
      }))();
    },
    handleSubmitNews: function handleSubmitNews() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var canSubmit;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this6.$refs.form.validate();

              case 2:
                canSubmit = _context4.sent;

                if (canSubmit) {
                  _this6.submitNews();
                }

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    }
  }
};